export const getToken = () => {
    const tokenValue = localStorage.getItem("tokenValue");
    const tokenType = localStorage.getItem("tokenType");
    return tokenValue && tokenType ? `${tokenType} ${tokenValue}` : null;
}

export const clearToken = () => {
    localStorage.removeItem("tokenValue")
    localStorage.removeItem("tokenType")
}